import styled from "styled-components";

import { Bolt as BoltSvg } from "../assets/Bolt";

export const Bolt = styled(BoltSvg)`
  position: absolute;
  z-index: -1;
  max-height: 100%;
  width: 506px;
  height: 380px;
  transform: rotate(-2deg);
  right: -117px;
  top: 520px;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    width: 1103px;
    height: 830px;
    right: -430px;
    top: -34px;
  }

  ${({ theme }) => theme.breakpointsV2.smallDesktop} {
    right: -278px;
  }
`;

export const Root = styled.div`
  z-index: 0;
  position: relative;
  width: 100%;
  height: 100%;

  padding: ${({ theme }) => theme.spacing.spacing_96} 0;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    padding: ${({ theme }) => theme.spacing.spacing_160} 0;
  }
`;
